import uuid from "uuid/v4"
import {
  unique
} from "shorthash"

import {
  get,
  pipe
} from "../../utils"

// Action Types

export const routerActionTypes = {
  MYMAZDA_FETCH_START: "MYMAZDA_FETCH_START",
  MYMAZDA_FETCH_ERROR: "MYMAZDA_FETCH_ERROR",
  MYMAZDA_FETCH_SUCCESS: "MYMAZDA_FETCH_SUCCESS",
  MYMAZDA_UPDATE_ROUTE_COMPONENTS: "MYMAZDA_UPDATE_ROUTE_COMPONENTS",
  MYMAZDA_REGISTER_ROUTES: "MYMAZDA_REGISTER_ROUTES",
  MYMAZDA_HYDRATE_ROUTE_COMPONENTS: "MYMAZDA_HYDRATE_ROUTE_COMPONENTS",
  MYMAZDA_REFRESH_CURRENT_ROUTE: "MYMAZDA_REFRESH_CURRENT_ROUTE"
}

export const flashActionTypes = {
  MYMAZDA_FLASH_ADD_MESSAGE: "MYMAZDA_FLASH_ADD_MESSAGE",
  MYMAZDA_FLASH_REMOVE_MESSAGE: "MYMAZDA_FLASH_REMOVE_MESSAGE"
}

export const serviceActionTypes = {
  MYMAZDA_UPDATE_SERVICE_DETAILS: "MYMAZDA_UPDATE_SERVICE_DETAILS"
}

export const notificationsActionTypes = {
  MYMAZDA_SAVE_NOTIFICATIONS: "MYMAZDA_SAVE_NOTIFICATIONS"
}

export const uiStateActionTypes = {
  MYMAZDA_TOGGLE_NAV: "MYMAZDA_TOGGLE_NAV",
  MYMAZDA_TOGGLE_USER: "MYMAZDA_TOGGLE_USER",
  MYMAZDA_TOGGLE_NOTIFICATIONS: "MYMAZDA_TOGGLE_NOTIFICATIONS",
  MYMAZDA_EXPAND_NAV_ITEM: "MYMAZDA_EXPAND_NAV_ITEM",
  MYMAZDA_TOGGLE_NAV_ITEM: "MYMAZDA_TOGGLE_NAV_ITEM",
  MYMAZDA_CLOSE_ALL: "MYMAZDA_CLOSE_ALL"
}

export const actionTypes = {
  ...routerActionTypes,
  ...flashActionTypes,
  ...serviceActionTypes,
  ...notificationsActionTypes,
  ...uiStateActionTypes
}

const toggleNav = () => ({
  type: uiStateActionTypes.MYMAZDA_TOGGLE_NAV,
  payload: {}
})

const toggleUser = () => ({
  type: uiStateActionTypes.MYMAZDA_TOGGLE_USER,
  payload: {}
})

const toggleNotifications = () => ({
  type: uiStateActionTypes.MYMAZDA_TOGGLE_NOTIFICATIONS,
  payload: {}
})

const closeAllNav = () => ({
  type: uiStateActionTypes.MYMAZDA_CLOSE_ALL,
  payload: {}
})

const expandNavItem = index => ({
  type: uiStateActionTypes.MYMAZDA_EXPAND_NAV_ITEM,
  payload: {
    index
  }
})

const toggleNavItem = index => ({
  type: uiStateActionTypes.MYMAZDA_TOGGLE_NAV_ITEM,
  payload: {
    index
  }
})

const addFlashMessage = (message, type = "MESSAGE", timeout = 10000) => ({
  type: flashActionTypes.MYMAZDA_FLASH_ADD_MESSAGE,
  payload: {
    id: uuid(),
    timeout,
    message,
    type
  }
})

const removeFlashMessage = id => ({
  type: flashActionTypes.MYMAZDA_FLASH_REMOVE_MESSAGE,
  payload: {
    id
  }
})

const hydrateRouteComponents = (route, components) => ({
  type: routerActionTypes.MYMAZDA_HYDRATE_ROUTE_COMPONENTS,
  payload: {
    components,
    route,
    key: unique(route || "")
  }
})

const registerRoutes = routes => ({
  type: routerActionTypes.MYMAZDA_REGISTER_ROUTES,
  payload: {
    routes
  }
})

const refreshCurrentRoute = () => ({
  type: routerActionTypes.MYMAZDA_REFRESH_CURRENT_ROUTE
})

// Action Creators
const updateRouteComponents = (route, search) => ({
  type: routerActionTypes.MYMAZDA_UPDATE_ROUTE_COMPONENTS,
  payload: {
    route,
    search,
    key: unique(`${route}${search}`)
  }
})

const updateServiceDetails = (service, vin) => ({
  type: serviceActionTypes.MYMAZDA_UPDATE_SERVICE_DETAILS,
  payload: {
    service,
    vin
  }
})

const saveNotifications = (notifications) => ({
  type: notificationsActionTypes.MYMAZDA_SAVE_NOTIFICATIONS,
  payload: {
    notifications
  }
})

export const actionCreators = {
  hydrateRouteComponents,
  updateRouteComponents,
  registerRoutes,
  addFlashMessage,
  removeFlashMessage,
  updateServiceDetails,
  saveNotifications,
  refreshCurrentRoute,
  toggleNav,
  closeAllNav,
  expandNavItem,
  toggleNavItem,
  toggleUser,
  toggleNotifications
}

// Selectors

const getMymazda = get("mymazda")

const getMymazdaPage = (vehicleId, route) => pipe(getMymazda, get(`${vehicleId}.${route}`))

const getRoutes = pipe(getMymazda, get("routes"))

const getUiState = pipe(getMymazda, get("uiState"))

const getRoute = route => pipe(getRoutes, get(route))
const getRouteComponents = (route, search) =>
  pipe(getMymazda, get("cache"), get(unique(`${route}${search}`)))

const getServices = pipe(getMymazda, get("service"))
const getService = vin => pipe(getServices, get(vin))

const getNotifications = pipe(getMymazda, get("notifications"))

// @todo weird hacky functional programming fix this
const ifDef = (suc, fail) => state => (!state ? fail() : suc(state))
const getBreadcrumb = route => pipe(getRoute(route), ifDef(get("breadcrumb"), () => []))

const getFlashMessages = pipe(getMymazda, get("flashMessages"))

export const selectors = {
  getRouteComponents,
  getMymazda,
  getMymazdaPage,
  getRoutes,
  getBreadcrumb,
  getRoute,
  getFlashMessages,
  getServices,
  getService,
  getNotifications,
  getUiState
}



// WEBPACK FOOTER //
// ./src/store/actions/mymazda.js